// extracted by mini-css-extract-plugin
export default {"casePage":"CasePage_casePage__IPBdJ","projectDescription":"CasePage_projectDescription__MiLvW","images":"CasePage_images__hg2Rd","mute":"CasePage_mute__3LM4O"};